import $ from 'jquery';
import VanillaTilt from 'vanilla-tilt';

import Lenis from '@studio-freight/lenis'

const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
  smooth: true,
  mouseMultiplier: 1.4,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
})


function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

$('#progress-bar').addClass('_20');

VanillaTilt.init(document.querySelector(".main-img"), {
  reverse:                false,  // reverse the tilt direction
  max:                    15,     // max tilt rotation (degrees)
  startX:                 0,      // the starting tilt on the X axis, in degrees.
  startY:                 0,      // the starting tilt on the Y axis, in degrees.
  perspective:            1000,   // Transform perspective, the lower the more extreme the tilt gets.
  scale:                  1,      // 2 = 200%, 1.5 = 150%, etc..
  speed:                  300,    // Speed of the enter/exit transition
  transition:             true,   // Set a transition on enter/exit.
  axis:                   null,   // What axis should be disabled. Can be X or Y.
  reset:                  true,   // If the tilt effect has to be reset on exit.
  easing:                 "cubic-bezier(.03,.98,.52,.99)",    // Easing on enter/exit.
  glare:                  true,  // if it should have a "glare" effect
  "max-glare":            .5,      // the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
  "glare-prerender":      false,  // false = VanillaTilt creates the glare elements for you, otherwise
                                  // you need to add .js-tilt-glare>.js-tilt-glare-inner by yourself
  "mouse-event-element":  null,   // css-selector or link to an HTML-element that will be listening to mouse events
  "full-page-listening":  false,  // If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
  gyroscope:              true,   // Boolean to enable/disable device orientation detection,
  gyroscopeMinAngleX:     -45,    // This is the bottom limit of the device angle on X axis, meaning that a device rotated at this angle would tilt the element as if the mouse was on the left border of the element;
  gyroscopeMaxAngleX:     45,     // This is the top limit of the device angle on X axis, meaning that a device rotated at this angle would tilt the element as if the mouse was on the right border of the element;
  gyroscopeMinAngleY:     -45,    // This is the bottom limit of the device angle on Y axis, meaning that a device rotated at this angle would tilt the element as if the mouse was on the top border of the element;
  gyroscopeMaxAngleY:     45,     // This is the top limit of the device angle on Y axis, meaning that a device rotated at this angle would tilt the element as if the mouse was on the bottom border of the element;
  gyroscopeSamples:       10      // How many gyroscope moves to decide the starting position.
});

$(".menu-icon").click(function() {
  if ($(".main-html").hasClass("nav-active")) {
    $(".main-html").removeClass('nav-active');

  } else {
    $(".main-html").addClass('nav-active');
  }
});

//Function to mark an item from a section width a css class.
$(".link-item").click(function() {
  var get = $(this).attr('href');
  $("html").removeClass('nav-active');
  setTimeout(
    function() {
      $('html,body ').animate({
        scrollTop: $(get).offset().top - 112
      }, 1000);
      return false;
    }, 800);
  return false;
});

$(".to-top").click(function() {
  var get = "#studio";
  $('html,body ').animate({
    scrollTop: $(get).offset().top - 112
  }, 1000);

  return false;
});



$(document).ready(function() {
  $(".tinydude").hover(
    function() {
      $(this).get(0).play();
      $(this).attr('loop', 'loop');
    },
    function() {
      $(this).get(0).pause();
    });
  $(".icon-a-missions").hover(
    function() {
      $(this).get(0).play();
      $(this).attr('loop', 'loop');
    },
    function() {
      $(this).get(0).pause();
    });
});



function supportsVideoType(type) {
  let video;

  // Allow user to create shortcuts, i.e. just "webm"
  let formats = {
    webm: 'video/webm; codecs="vp8, vorbis"',
  };

  if (!video) {
    video = document.createElement('video')
  }

  return video.canPlayType(formats[type] || type);
}

// Usage
if (supportsVideoType('webm') === "probably") {
  // Set the video to webm

} else {
  // Set the video to mpeg or mp4
  $('.img-studio').addClass('wbm-support');
  $('.serv-title').addClass('wbm-support');
  $('.text-mission').addClass('wbm-support');
  $('.text-about').addClass('wbm-support');
}
var eta = true;
document.onreadystatechange = function(e) {
  if (document.readyState == "complete") {
    var all = document.getElementsByTagName("*");
    for (var i = 0, max = all.length; i < max; i++) {
      set_ele(all[i]);
    }

  }
}

function check_element(ele) {
  var all = document.getElementsByTagName("*");
  var totalele = all.length;
  var per_inc = 100 / all.length;

  if ($(ele).on()) {
    var prog_width = per_inc + Number(document.getElementById("progress-bar").getAttribute('aria-valuenow'));
    document.getElementById("progress-bar").setAttribute('aria-valuenow', prog_width);
      setInterval(function() {
        $('#progress-bar').removeClass('_20');
        $('#progress-bar').css('width', prog_width + "%");
        if(prog_width >= 100)
         {
        $('.loading__wrapper').fadeOut( 1000, function() {
          $(".loading__wrapper").hide();
      });
        }
      }, 1000);


  } else {
    set_ele(ele);
  }
}

function set_ele(set_element) {
  check_element(set_element);
}
